import type { ReactNode } from 'react';
import {
    InfoPanel,
    InfoPanelGroup,
    InfoPanelCard,
    InfoPanelTitle,
    InfoPanelRow,
    InfoPanelValue,
} from '@/components';

export interface DirectoryItemInfoField {
    title: string;
    value: string | ReactNode;
    icon?: ReactNode;
}

interface DirectoryItemInfoPanelProps {
    fields: DirectoryItemInfoField[];
}

export function DirectoryItemInfoPanel({
    fields,
}: DirectoryItemInfoPanelProps) {
    const midpoint = Math.ceil(fields.length / 2);
    const firstGroup = fields.slice(0, midpoint);
    const secondGroup = fields.slice(midpoint);

    return (
        <InfoPanel>
            <InfoPanelGroup>
                {firstGroup.map((field, index) => (
                    <InfoPanelCard key={index}>
                        <InfoPanelTitle>{field.title}</InfoPanelTitle>
                        <InfoPanelRow>
                            {field.icon}
                            <InfoPanelValue>{field.value}</InfoPanelValue>
                        </InfoPanelRow>
                    </InfoPanelCard>
                ))}
            </InfoPanelGroup>

            {secondGroup.length > 0 && (
                <InfoPanelGroup>
                    {secondGroup.map((field, index) => (
                        <InfoPanelCard key={index}>
                            <InfoPanelTitle>{field.title}</InfoPanelTitle>
                            <InfoPanelRow>
                                {field.icon}
                                <InfoPanelValue>{field.value}</InfoPanelValue>
                            </InfoPanelRow>
                        </InfoPanelCard>
                    ))}
                </InfoPanelGroup>
            )}
        </InfoPanel>
    );
}
